<template>
  <div>
    <app-cells>
      <h1 class="title">Safari Schedule</h1>
    </app-cells>
    <app-tabs :tabs="tabs_to_show" />
    <transition name="fade" mode="out-in">
      <router-view :key="$route.name" />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'SafariScheduleLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'safari-schedule-list', label: 'List', roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_manager', 'sales_supervisor'] },
        { name: 'safari-schedule-calendar', label: 'Calendar', roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_manager', 'sales_supervisor'] },
        { name: 'safari-schedule-honeymooners', label: 'Honeymooners', roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_manager', 'sales_supervisor'] },
        { name: 'safari-schedule-problems', label: 'Problems', roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant'] },
      ],
      tabs_to_show: [],
    }
  },
  created() {
    this.tabs_to_show = this.tabs.filter(item => item.roles.some(role => this.$store.state.userGroups.some(groupRole => groupRole.code === role)))
  },
}
</script>
